export const parseCommon = (stories) => {
  const results = {
    footer: stories.find((n) => n.name === 'footer').content,
    errorStory: stories.find((n) => n.name === 'error_code').content,
    switchLocator: stories.find((n) => n.name === 'change_location').content,
    signupNewsletter: stories.find((n) => n.name === 'signup_newsletter')
      .content,
    searchStory: stories.find((n) => n.name === 'search_bar').content,
    popupLogin: stories.find((n) => n.name === 'popup_login').content,
    recentlyViewed: stories.find((n) => n.name === 'recently_viewed').content,
    snackbarsStory: stories.find((n) => n.name === 'notification_snackbar')
      .content,
    topBarSwitch: stories.find((n) => n.name === 'top_bar_switch_location')
      .content,
    subHeader: stories.find((n) => n.name === 'surheader_banner').content,
    productsFlaps: stories.find((n) => n.name === 'flaps').content,
    errorsForm: stories.find((n) => n.name === 'errors_form').content,
    confirmationStory: stories.find(
      (n) => n.name === 'notification_confirmation'
    ).content,
    commonWishlistStory: stories.find((n) => n.name === 'wishlist_common')
      .content,
    navigationStory: stories.find((n) => n.name === 'navigation').content,
    menuStory: stories.find((n) => n.name === 'menu').content,
    search2Story: stories.find((n) => n.name === 'Collection Page').content,
    bannersStory: stories.find((n) => n.name === 'Banners collection page')
      .content,
    categoryStory: stories.find((n) => n.name === 'Category Left Menu').content,
    sizeGuide: stories.find((n) => n.name === 'size_guide').content,
  }
  return results
}
